export default class StoreChangeConfirm {
    constructor() {
        this.state = 'fill';
        this.bind();
    }

    popupTemplate() {
        return `
            <div class="modal fade simple-modal callback-modal" id="callback-modal" tabindex="-1" role="dialog"  aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">

                        <div class="modal-body">

                            <button type="button" class="close simple-modal__close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                            <div class="simple-modal__title">Вы действительно хотите сменить склад?</div>
                            <div class="simple-modal__subtitle">
                                Корзина будет очищенна
                            </div>

                            <form class="callback-modal__form">

                                <div class="callback-modal__btn-block">
                                    <button type="submit" class="button-icon callback-modal__submit">
                                        <span class="button-icon__left">
                                            <img class="button-icon__icon" src="${app.assetPath}/img/icons/smartphone-white.svg" alt="" />
                                        </span>
                                        <span class="button-icon__right">Да</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
`;
    }

    bind() {
        //$('.header-middle__callback-link, .footer__callback').on('click', this.onTriggerClick.bind(this));
        //this.$popup.on('hidden.bs.modal', this.onClose.bind(this));
    }

    bindLazy() {
        this.$popup.find('.callback-modal__form').on('submit', this.onSubmit.bind(this));
    }

    onTriggerClick(e) {
        e.preventDefault();
        this.show();
    }

    show() {
        if (!this.$popup) {
            // Because of empty #text-node
            this.$popup = $(this.popupTemplate()).eq(0);
            $('body').append(this.$popup);
            this.bindLazy();
        }

        this.setState('fill');
        this.$popup.modal('show');
    }

    setState(state) {
        switch (state) {
            case 'sent':
                this.$popup.find('.callback-modal__success').removeClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Закрыть');
                this.state = 'sent';
                break;

            case 'fill':
                this.$popup.find('.callback-modal__success').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__left').addClass('hidden');
                this.$popup.find('.callback-modal__submit .button-icon__right').text('Да');
                this.$popup.find('form').get(0).reset();
                this.state = 'fill';
                break;
        }
    }

    onSubmit(e) {
        e.preventDefault();
        this.$popup.modal('hide');
        this.storeManagerPopup.setStore( this.setStoreData.cityId, this.setStoreData.storeId );
    }
}
